import { GestionProducto } from "../interfaces/gestion-Productos.interfaces"

export const gestionProductoInitialState: GestionProducto = {
  agregarProducto: {
    formProduct: {
      //sucursal: '',
      codigoSucursal: '',
      codigoProducto: '',
      precioUnitario: '',
      precioSinIVA: '',
      iva: '',
      //servicioProducto: '',
      unidadMedida: '',
      descripcion: '',
      impuestoDistintoAlIVA: '',
      tipoItem:'',
      activo: false,
      sucursalesAsignadas: [],
    },
    formErrorProduct: {
      //sucursal: '',
      codigoSucursal: '',
      codigoProducto: '',
      precioUnitario: '',
      precioSinIVA: '',
      iva: '',
      //servicioProducto: '',
      unidadMedida: '',
      descripcion: '',
      impuestoDistintoAlIVA: '',
      tipoItem:'',
      activo: false,
      sucursalesAsignadas: [],
    },
    codeVerify: {
      code: '',
      error: '',
    },
    paginaActual: 0,
    modals: {
      activoConfirmacion: false,
      activoConfirmar: false,
      activoCreado: false,
      activoValidaciones: false,
      erroresValidaciones: [],   
    },
    catalogos: {
      sucursales: [],
    },
    sucursalesAsignadas: [],
    datosProductoAgregado: null,
  },
  listarProductos: {
    arrayProductos: [],
    productos: [],
    formBuscar: {
      //sucursal: '',
      codigoSucursal: '',
      codigoProducto: '',
      precioUnitario: '',
      precioSinIVA: '',
      iva: '',
      //servicioProducto: '',
      unidadMedida: '',
      descripcion: '',
      impuestoDistintoAlIVA: '',
      tipoItem:'',
      activo: false,
      sucursalesAsignadas: [],
    },
    modales: {
      activeEliminar: false,
      activeEstatus: false,
      activeSucursales: false,
      
    },
    catalogos: {
      sucursales: [],
    },
    sucursalesAsignadas: [],
    productoSeleccionado: null,
  },
  editarProducto: {
    productoSeleccionado: null,
    formProduct: {
      //sucursal: '',
      codigoSucursal: '',
      codigoProducto: '',
      precioUnitario: '',
      precioSinIVA: '',
      iva: '',
      //servicioProducto: '',
      unidadMedida: '',
      descripcion: '',
      impuestoDistintoAlIVA: '',
      tipoItem:'',
      activo: false,
      sucursalesAsignadas: [],
    },
    catalogos: {
      sucursales: [],
    },
    formErrorProduct: {
      //sucursal: '',
      codigoSucursal: '',
      codigoProducto: '',
      precioUnitario: '',
      precioSinIVA: '',
      iva: '',
      //servicioProducto: '',
      unidadMedida: '',
      descripcion: '',
      impuestoDistintoAlIVA: '',
      tipoItem:'',
      activo: false,
      sucursalesAsignadas: [],
    },
    modales: {
      activeEliminar: false,
    },
    sucursalesAsignadas: []
  },
  perfilProducto: {
    sucursal: '',
    codigoSucursal: '',
    codigoProducto: '',
    precioUnitario: '',
    precioSinIVA: '',
    iva: '',
    servicioProducto: '',
    unidadMedida: '',
    descripcion: '',
    impuestoDistintoAlIVA: '',
    tipoItem:'',
    activo: false,
  },
  sucursales: {
    dataSucursales: [],
    dataDocumentos: [],
    formSucursal: {
      idsucursal: '',
      mode: 'add',
      nombre: '',
      direccion: '',
      descripcion: '',
      codigo: '',
    },
    errorsSucursal: {
      idsucursal: '',
      mode: 'add',
      nombre: '',
      direccion: '',
      descripcion: '',
      codigo: '',
    },
  },

  //AÑADIDO: inicializar productosFileDataCargada
  /* productosFileDataCargada: {
    dataFile: [],
    formProductos: {
      sucursal: '',
      codigoSucursal: '',
      codigoProducto: '',
      precioUnitario: '',
      precioSinIVA: '',
      iva: '',
      servicioProducto: '',
      unidadMedida: '',
      descripcion: '',
      impuestoDistintoAlIVA: '',
    },
    fileBase64: '',
  }, */
}
